import iconImg from '@assets/svgs/preload-icon-file-img.svg'
import iconDoc from '@assets/svgs/preload-icon-file-doc.svg'
import iconPpt from '@assets/svgs/preload-icon-file-ppt.svg'
import iconXls from '@assets/svgs/preload-icon-file-xls.svg'
import iconPdf from '@assets/svgs/preload-icon-file-pdf.svg'
import iconTxt from '@assets/svgs/preload-icon-file-txt.svg'
import iconAudio from '@assets/svgs/preload-icon-file-audio.svg'
import iconLrc from '@assets/svgs/preload-icon-file-lrc.svg'
import iconVideo from '@assets/svgs/preload-icon-file-video.svg'
import iconZip from '@assets/svgs/preload-icon-file-zip.svg'
import icon7z from '@assets/svgs/preload-icon-file-7z.svg'
import iconRar from '@assets/svgs/preload-icon-file-rar.svg'
import iconJar from '@assets/svgs/preload-icon-file-jar.svg'
import iconApk from '@assets/svgs/preload-icon-file-apk.svg'
import iconHtml from '@assets/svgs/preload-icon-file-html.svg'
import iconFolder from '@assets/svgs/preload-icon-file-folder.svg'
import iconXmind from '@assets/svgs/preload-icon-file-xmind.svg'
import iconCompressedFile from '@assets/svgs/preload-icon-file-compressed-file.svg'
import iconCad from '@assets/svgs/preload-icon-file-cad.svg'
import iconKey from '@assets/svgs/preload-icon-file-key.svg'
import iconPages from '@assets/svgs/preload-icon-file-pages.svg'
import iconNumbers from '@assets/svgs/preload-icon-file-numbers.svg'
import iconMd from '@assets/svgs/preload-icon-file-md.svg'
import iconVcf from '@assets/svgs/preload-icon-file-vcf.svg'
import iconTheme from '@assets/svgs/preload-icon-file-theme.svg'
import iconTorrent from '@assets/svgs/preload-icon-file-torrent.svg'
import iconCalendar from '@assets/svgs/preload-icon-file-calendar.svg'
import iconVmsg from '@assets/svgs/preload-icon-file-vmsg.svg'
import iconPsd from '@assets/svgs/preload-icon-file-psd.svg'
import iconAI from '@assets/svgs/preload-icon-file-ai.svg'
import iconExe from '@assets/svgs/preload-icon-file-exe.svg'
import iconDMG from '@assets/svgs/preload-icon-file-dmg.svg'
import iconVisio from '@assets/svgs/preload-icon-file-visio.svg'
import iconUnknown from '@assets/svgs/preload-icon-file-unknown.svg'

const SUFFIX_NAME_FOLDER = 'folder'

export const SUFFIX_TYPE_FOLDER = 7

const enum FileSuffix {
  XLS = 'xls',
  XLSX = 'xlsx',
  DOCX = 'docx',
  DOC = 'doc',
  PPT = 'ppt',
  PPTX = 'pptx',
  PDF = 'pdf',
  TXT = 'txt',
  PNG = 'png',
  HEIF = 'heif',
  SVG = 'svg',
  JPG = 'jpg',
  JPEG = 'jpeg',
  GIF = 'gif',
  MP3 = 'mp3',
  LRC = 'lrc',
  MP2 = 'mp2',
  FLAC = 'flac',
  OGG = 'ogg',
  AAC = 'aac',
  M4A = 'm4a',
  WAV = 'wav',
  APE = 'ape',
  MP4 = 'mp4',
  WMA = 'wma',
  AVI = 'avi',
  RM = 'rm',
  RMVB = 'rmvb',
  FLV = 'flv',
  MPG = 'mpg',
  MOV = 'mov',
  MKV = 'mkv',
  ZIP = 'zip',
  RAR = 'rar',
  JAR = 'jar',
  '7Z' = '7z',
  APK = 'apk',
  HTML = 'html',
  HTM = 'htm',
  FOLDER = 'folder',
  CHM = 'chm',
  EBK2 = 'ebk2',
  EBK3 = 'ebk3',
  MOBI = 'mobi',
  EPUB = 'epub',

  AMR = 'amr',
  MPGA = 'mpga',
  AWB = 'awb',
  OGA = 'oga',
  MKA = 'mka',
  MID = 'mid',
  MIDI = 'midi',
  XMF = 'xmf',
  RTTTL = 'rtttl',
  SMF = 'smf',
  IMY = 'imy',
  RTX = 'rtx',
  OTA = 'ota',
  MXMF = 'mxmf',
  CUE = 'cue',
  RA = 'ra',
  DTS = 'dts',
  OMC3 = 'omc3',
  ALM3 = 'alm3',
  ALM4 = 'alm4',
  DSF = 'dsf',
  DFF = 'dff',
  EC3 = 'ec3',
  'O-ALM4' = 'o-alm4',
  'O-ALM5' = 'o-alm5',
  'O-ALM6' = 'o-alm6',
  'O-ALM7' = 'o-alm7',

  DL = 'dl',
  DIF = 'dif',
  DV = 'dv',
  FLI = 'fli',
  M4V = 'm4v',
  TS = 'ts',
  MPEG = 'mpeg',
  MPE = 'mpe',
  VOB = 'vob',
  QT = 'qt',
  MXU = 'mxu',
  WEBM = 'webm',
  LSF = 'lsf',
  LSX = 'lsx',
  MNG = 'mng',
  ASF = 'asf',
  ASX = 'asx',
  WM = 'wm',
  WMV = 'wmv',
  WMX = 'wmx',
  WVX = 'wvx',
  MOVIE = 'movie',
  WRF = 'wrf',
  NAVI = 'navi',
  RAM = 'ram',
  F4V = 'f4v',
  QSV = 'qsv',
  MPEG1 = 'mpeg1',
  MPEG2 = 'mpeg2',
  DIVX = 'divx',
  XVID = 'xvid',
  MOD = 'mod',
  '3GP' = '3gp',
  '3G2' = '3g2',
  BMP = 'bmp',
  WBMP = 'wbmp',
  WEBP = 'webp',
  DNG = 'dng',
  CR2 = 'cr2',
  NEF = 'nef',
  NRW = 'nrw',
  ARW = 'arw',
  RW2 = 'rw2',
  ORF = 'orf',
  RAF = 'raf',
  PEF = 'pef',
  SRW = 'srw',
  GLTF = 'gltf',
  GLB = 'glb',
  HEIC = 'heic',

  DOTX = 'dotx',
  DOCM = 'docm',
  DOTM = 'dotm',
  WPS = 'wps',
  WPSS = 'wpss',
  WPT = 'wpt',
  ET = 'et',
  ETT = 'ett',
  ETS = 'ets',
  XLTX = 'xltx',
  XLSM = 'xlsm',
  XLTM = 'xltm',

  POT = 'pot',
  PPA = 'ppa',
  PPS = 'pps',
  PWZ = 'pwz',
  DPT = 'dpt',
  PPTM = 'pptm',
  PPSM = 'ppsm',
  POTM = 'potm',
  DPS = 'dps',
  DPSS = 'dpss',

  XMIND = 'xmind',

  GZ = 'gz',
  TGZ = 'tgz',

  DWG = 'dwg',
  DWT = 'dwt',
  DXF = 'dxf',

  KEY = 'key',

  PAGES = 'pages',

  NUMBERS = 'numbers',

  MD = 'md',

  VCF = 'vcf',

  THEME = 'theme',

  TORRENT = 'torrent',

  ICS = 'ics',
  VCS = 'vcs',

  VMSG = 'vmsg',
  PSD = 'psd',
  AI = 'ai',
  EXE = 'exe',
  DMG = 'dmg',

  VSD = 'vsd',
  VSDM = 'vsdm',
  VSDX = 'vsdx',
  VSS = 'vss',
  VST = 'vst',
  VSTM = 'vstm',
  VSTX = 'vstx',
}

const SearchIconMap = new Map<FileSuffix, string>([
  [FileSuffix.XLS, iconXls],
  [FileSuffix.XLSX, iconXls],
  [FileSuffix.ET, iconXls],
  [FileSuffix.ETT, iconXls],
  [FileSuffix.ETS, iconXls],
  [FileSuffix.XLTX, iconXls],
  [FileSuffix.XLSM, iconXls],
  [FileSuffix.XLTM, iconXls],

  [FileSuffix.DOC, iconDoc],
  [FileSuffix.DOCX, iconDoc],

  [FileSuffix.DOTX, iconDoc],
  [FileSuffix.DOCM, iconDoc],
  [FileSuffix.DOTM, iconDoc],
  [FileSuffix.WPS, iconDoc],
  [FileSuffix.WPSS, iconDoc],
  [FileSuffix.WPT, iconDoc],
  [FileSuffix.PPT, iconPpt],
  [FileSuffix.PPTX, iconPpt],

  [FileSuffix.POT, iconPpt],
  [FileSuffix.PPA, iconPpt],
  [FileSuffix.PPS, iconPpt],
  [FileSuffix.PWZ, iconPpt],
  [FileSuffix.DPT, iconPpt],
  [FileSuffix.PPTM, iconPpt],
  [FileSuffix.PPSM, iconPpt],
  [FileSuffix.POTM, iconPpt],
  [FileSuffix.DPS, iconPpt],
  [FileSuffix.DPSS, iconPpt],

  [FileSuffix.PDF, iconPdf],
  [FileSuffix.TXT, iconTxt],

  [FileSuffix.CHM, iconTxt],
  [FileSuffix.EBK2, iconTxt],
  [FileSuffix.EBK3, iconTxt],
  [FileSuffix.MOBI, iconTxt],
  [FileSuffix.EPUB, iconTxt],
  [FileSuffix.PNG, iconImg],
  [FileSuffix.SVG, iconImg],
  [FileSuffix.JPG, iconImg],
  [FileSuffix.JPEG, iconImg],
  [FileSuffix.GIF, iconImg],

  [FileSuffix.BMP, iconImg],
  [FileSuffix.WBMP, iconImg],
  [FileSuffix.WEBP, iconImg],
  [FileSuffix.DNG, iconImg],
  [FileSuffix.CR2, iconImg],
  [FileSuffix.NEF, iconImg],
  [FileSuffix.NRW, iconImg],
  [FileSuffix.ARW, iconImg],
  [FileSuffix.RW2, iconImg],
  [FileSuffix.ORF, iconImg],
  [FileSuffix.RAF, iconImg],
  [FileSuffix.PEF, iconImg],
  [FileSuffix.SRW, iconImg],
  [FileSuffix.GLTF, iconImg],
  [FileSuffix.GLB, iconImg],
  [FileSuffix.HEIC, iconImg],
  [FileSuffix.HEIF, iconImg],

  [FileSuffix.MP3, iconAudio],
  [FileSuffix.WMA, iconAudio],
  [FileSuffix.MP2, iconAudio],
  [FileSuffix.FLAC, iconAudio],
  [FileSuffix.OGG, iconAudio],
  [FileSuffix.AAC, iconAudio],
  [FileSuffix.M4A, iconAudio],
  [FileSuffix.WAV, iconAudio],
  [FileSuffix.APE, iconAudio],

  [FileSuffix.AMR, iconAudio],
  [FileSuffix.MPGA, iconAudio],
  [FileSuffix.AWB, iconAudio],
  [FileSuffix.OGA, iconAudio],
  [FileSuffix.MKA, iconAudio],
  [FileSuffix.MID, iconAudio],
  [FileSuffix.MIDI, iconAudio],
  [FileSuffix.XMF, iconAudio],
  [FileSuffix.RTTTL, iconAudio],
  [FileSuffix.SMF, iconAudio],
  [FileSuffix.IMY, iconAudio],
  [FileSuffix.RTX, iconAudio],
  [FileSuffix.OTA, iconAudio],
  [FileSuffix.MXMF, iconAudio],
  [FileSuffix.CUE, iconAudio],
  [FileSuffix.RA, iconAudio],
  [FileSuffix.DTS, iconAudio],
  [FileSuffix.OMC3, iconAudio],
  [FileSuffix.ALM3, iconAudio],
  [FileSuffix.ALM4, iconAudio],
  [FileSuffix.DSF, iconAudio],
  [FileSuffix.DFF, iconAudio],
  [FileSuffix.EC3, iconAudio],
  [FileSuffix['O-ALM4'], iconAudio],
  [FileSuffix['O-ALM5'], iconAudio],
  [FileSuffix['O-ALM6'], iconAudio],
  [FileSuffix['O-ALM7'], iconAudio],

  [FileSuffix.LRC, iconLrc],
  [FileSuffix.MP4, iconVideo],
  [FileSuffix.AVI, iconVideo],
  [FileSuffix.RM, iconAudio],
  [FileSuffix.RMVB, iconVideo],
  [FileSuffix.FLV, iconVideo],
  [FileSuffix.MPG, iconVideo],
  [FileSuffix.MOV, iconVideo],
  [FileSuffix.MKV, iconVideo],
  [FileSuffix.DL, iconVideo],
  [FileSuffix.DIF, iconVideo],
  [FileSuffix.DV, iconVideo],
  [FileSuffix.FLI, iconVideo],
  [FileSuffix.M4V, iconVideo],
  [FileSuffix.TS, iconVideo],
  [FileSuffix.MPEG, iconVideo],
  [FileSuffix.MPE, iconVideo],
  [FileSuffix.VOB, iconVideo],
  [FileSuffix.QT, iconVideo],
  [FileSuffix.MXU, iconVideo],
  [FileSuffix.WEBM, iconVideo],
  [FileSuffix.LSF, iconVideo],
  [FileSuffix.LSX, iconVideo],
  [FileSuffix.MNG, iconVideo],
  [FileSuffix.ASF, iconVideo],
  [FileSuffix.ASX, iconVideo],
  [FileSuffix.WM, iconVideo],
  [FileSuffix.WMV, iconVideo],
  [FileSuffix.WMX, iconVideo],
  [FileSuffix.WVX, iconVideo],
  [FileSuffix.MOVIE, iconVideo],
  [FileSuffix.WRF, iconVideo],
  [FileSuffix.NAVI, iconVideo],
  [FileSuffix.RAM, iconVideo],
  [FileSuffix.F4V, iconVideo],
  [FileSuffix.QSV, iconVideo],
  [FileSuffix.MPEG1, iconVideo],
  [FileSuffix.MPEG2, iconVideo],
  [FileSuffix.DIVX, iconVideo],
  [FileSuffix.XVID, iconVideo],
  [FileSuffix.MOD, iconVideo],
  [FileSuffix['3GP'], iconVideo],
  [FileSuffix['3G2'], iconVideo],

  [FileSuffix.ZIP, iconZip],
  [FileSuffix.RAR, iconRar],
  [FileSuffix.JAR, iconJar],
  [FileSuffix['7Z'], icon7z],
  [FileSuffix.APK, iconApk],
  [FileSuffix.HTML, iconHtml],
  [FileSuffix.HTM, iconHtml],
  [FileSuffix.FOLDER, iconFolder],
  [FileSuffix.XMIND, iconXmind],
  [FileSuffix.GZ, iconCompressedFile],
  [FileSuffix.TGZ, iconCompressedFile],
  [FileSuffix.DWG, iconCad],
  [FileSuffix.DWT, iconCad],
  [FileSuffix.DXF, iconCad],
  [FileSuffix.KEY, iconKey],
  [FileSuffix.PAGES, iconPages],
  [FileSuffix.NUMBERS, iconNumbers],
  [FileSuffix.MD, iconMd],
  [FileSuffix.VCF, iconVcf],
  [FileSuffix.THEME, iconTheme],
  [FileSuffix.TORRENT, iconTorrent],
  [FileSuffix.ICS, iconCalendar],
  [FileSuffix.VCS, iconCalendar],
  [FileSuffix.VMSG, iconVmsg],
  [FileSuffix.PSD, iconPsd],
  [FileSuffix.AI, iconAI],
  [FileSuffix.EXE, iconExe],
  [FileSuffix.DMG, iconDMG],
  [FileSuffix.VSD, iconVisio],
  [FileSuffix.VSDM, iconVisio],
  [FileSuffix.VSDX, iconVisio],
  [FileSuffix.VSS, iconVisio],
  [FileSuffix.VST, iconVisio],
  [FileSuffix.VSTM, iconVisio],
  [FileSuffix.VSTX, iconVisio],
])

export const getIconBySuffix = (filename: string, fileType = 1) => {
  const SuffixIndex = filename.lastIndexOf('.')
  let icon = undefined

  if (fileType === SUFFIX_TYPE_FOLDER) {
    icon = SearchIconMap.get(<FileSuffix>SUFFIX_NAME_FOLDER)
  } else if (SuffixIndex !== -1) {
    const suffixName = filename.substring(SuffixIndex + 1).toLowerCase()

    icon = SearchIconMap.get(<FileSuffix>suffixName)
  }

  return icon ?? iconUnknown
}
